<template>
  <section class="section-base profile-view">
    <router-view />
  </section>
</template>

<script>
export default {
  name: "Profile",
  data: () => ({
    tab: 0
  })
}
</script>

<style scoped lang="scss">
  .tabs-content {
    padding: 72px 0;
  }


</style>
